<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        :title='item.data === undefined ? "评分编辑" : "评分编辑" '
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='400'
      >
        <template v-slot:content>
           <v-card class="px-5" elevation="0">
            <v-form ref="form" lazy-validation>

              <v-card outlined class="mb-5 px-2">
                <p class="my-1">总分：25分</p>
                <v-row>
                  <v-col cols="6" class="pb-0">客户服务分：10分</v-col>
                  <v-col cols="6" class="pb-0">个人专业度：5分</v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">团队协作分：5分</v-col>
                  <v-col cols="6">创新能力分：5分</v-col>
                </v-row>
              </v-card>

              <v-row>
                <v-col cols="12">
                  <v-text-field label="客户服务"  hide-details='auto' :rules="number" outlined v-model="form.serviceScore"></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-text-field label="个人专业度"  hide-details='auto' :rules="number" outlined v-model="form.professionScore"></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-text-field label="团队协作"  hide-details='auto' :rules="number" outlined v-model="form.teamScore"></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-text-field label="创新能力"  hide-details='auto' :rules="number" outlined v-model="form.innovateScore"></v-text-field>
                </v-col>
              </v-row>

            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text class="text--disabled" @click='item.show = false'>
                关闭
              </v-btn>
              <v-btn color="primary" :loading="loading" @click='save'>
                保存
              </v-btn>
            </v-card-actions>

          </v-card>
        </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { save } from '@/api/office/score.js'

  export default {
    name: 'ScoreEdit',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        loading: false,
        dateSelect: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        number: [
          value => /^[0-99]+.?[0-99]*$/.test(value) || '必须输入数字',
        ],
        penaltyTypeItems: [],
        form: {
          id: '',
          serviceScore: '',
          professionScore: '',
          teamScore: '',
          innovateScore: ''
        },
        defForm: {
          id: '',
          serviceScore: '',
          professionScore: '',
          teamScore: '',
          innovateScore: ''
        }
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      dialogChange (val) {
        this.item.show = val
        if (val && this.isEdit) {
          this.form = JSON.parse(JSON.stringify(this.item.data))
        } else {
          this.form = JSON.parse(JSON.stringify(this.defForm))
        }
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
